import DOMPurify from 'dompurify';

export const getMaintenanceContent = async () => {
  // todo-@elie: cdn.marqvision.com/maintenance.html 로 변경 예정
  const errorResponse = await fetch('https://s3.us-east-2.amazonaws.com/cdn.marqvision.com/maintenance.html', {
    cache: 'no-store',
  });

  let htmlContent: string;

  if (errorResponse.ok) {
    htmlContent = await errorResponse.text();
  } else {
    htmlContent = `
        <html>
        <head><title>Service Unavailable</title></head>
        <body>
          <h1>We're Currently Under Maintenance</h1>
          <p>We're working on improving our system to serve you better.
          We apologize for any inconvenience. We'll be back soon!</p>
        </body>
        </html>
      `;
  }

  return DOMPurify.sanitize(htmlContent);
};
